import ActionButton from 'components/ActionButton'
import SearchInput from 'components/SearchInput'
import styled, { css } from 'styled-components'
import { primaryBackgroundColor } from 'styles/styleVariables'

const PagePadding = css`
  padding-left: 1.875rem;
  padding-right: 1.875rem;
`

const LoadingContainer = styled.div`
  width: 50px;
  margin: auto;
`

const SearchControls = styled.div`
  grid-column: meta;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const StyledSearchInput = styled(SearchInput)`
  flex: 1;
  max-width: 24rem;
`

const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  ${PagePadding}
  > button {
    margin-right: 3.3rem;
  }
`

const Title = styled.h1`
  font-size: 24px;
  width: 100%;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  ${PagePadding}
`

const NewPrescriberLocationControls = styled.div`
  grid-column: actions;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

const StyledActionButton = styled(ActionButton)`
  background-color: ${primaryBackgroundColor};
`

export {
  LoadingContainer,
  SearchControls,
  StyledSearchInput,
  Content,
  Title,
  NewPrescriberLocationControls,
  StyledActionButton,
}
